module.exports = __webpack_public_path__ + "static/img/vh-saas-color-mixer-on.7b63513b.png";